import { trackSessionTask } from '~/utils/session-readiness'

export default function ({ store }) {
  if (store.$auth.loggedIn && !store.getters['offline/isOffline']) {
    // Keep normal route navigation non-blocking; the login overlay tracks this
    // initial request alongside the dashboard and sidebar when it is active.
    trackSessionTask('notifications', () => store.dispatch(
      'notificaciones/list',
      store.$auth.user.tipo === 'cliente' ? { cliente: store.$auth.user.uuid } : undefined
    ))
  }
}
